import React, { useEffect, useState, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
import { ThankYouPage } from './pages/ThankYouPage';
export type PageType = 'sales' | 'thankyou';
export function App() {
  const [currentPage, setCurrentPage] = useState<PageType>('sales');
  useEffect(() => {
    document.documentElement.lang = 'es';
    document.title = 'El Blindaje Operativo AFIP — Pack 5 Tomos + Bonos | Fegion';
    if (!document.querySelector('meta[name="viewport"]')) {
      var vp = document.createElement('meta');
      vp.name = 'viewport';
      vp.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(vp);
    }
    if (!document.querySelector('meta[name="theme-color"]')) {
      var tc = document.createElement('meta');
      tc.name = 'theme-color';
      tc.content = '#070E1A';
      document.head.appendChild(tc);
    }
    var tags: Array<[string, string, string]> = [['name', 'description', 'Protocolo de Auditoría Preventiva Anti-SIAp para Contadores Públicos Argentinos. 5 Tomos + 3 Bonos exclusivos. Blindá tu estudio contable contra requerimientos de AFIP con un sistema probado.'], ['property', 'og:title', 'El Blindaje Operativo AFIP — Pack 5 Tomos + Bonos'], ['property', 'og:description', 'Protocolo de Auditoría Preventiva para Contadores Públicos Argentinos. Blindá tu estudio contra AFIP.'], ['property', 'og:type', 'website'], ['property', 'og:image', 'https://cdn.magicpatterns.com/uploads/aYz2VWHF8Ao3Seb4BsFXiM/EL_BLINDAJE_OPERATIVO_ARCA(Ex-AFIP)_Pack_5_Tomos_2B_Bonos_-_by_Fegion_(1).jpg'], ['property', 'og:locale', 'es_AR']];
    tags.forEach(function (tag) {
      if (!document.querySelector('meta[' + tag[0] + '="' + tag[1] + '"]')) {
        var m = document.createElement('meta');
        m.setAttribute(tag[0], tag[1]);
        m.content = tag[2];
        document.head.appendChild(m);
      }
    });
    if (!document.querySelector('link[rel="canonical"]')) {
      var c = document.createElement('link');
      c.rel = 'canonical';
      c.href = window.location.origin + window.location.pathname;
      document.head.appendChild(c);
    }
  }, []);
  // Meta Pixel — deferred 4s after load
  useEffect(() => {
    function loadPixel() {
      if (document.getElementById('fb-pixel-init')) return;
      var s = document.createElement('script');
      s.id = 'fb-pixel-init';
      s.innerHTML = '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");fbq("init","904978025482552");fbq("track","PageView");';
      document.head.appendChild(s);
      var img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
      document.body.appendChild(img);
    }
    if (document.readyState === 'complete') {
      setTimeout(loadPixel, 4000);
    } else {
      window.addEventListener('load', function () {
        setTimeout(loadPixel, 4000);
      }, {
        once: true
      });
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  return <div className="min-h-screen bg-navy-900 text-offwhite" data-id="element-0">
      {currentPage === 'sales' && <SalesPage navigate={function (p: PageType) {
      setCurrentPage(p);
    }} data-id="element-1" />}
      {currentPage === 'thankyou' && <ThankYouPage navigate={function (p: PageType) {
      setCurrentPage(p);
    }} data-id="element-2" />}
    </div>;
}